import React from 'react'
import styled from 'styled-components'
import Button from '../button/Button'
import type {ButtonProps} from '../button/Button'
import Grid from '../grid/Grid'
import Heading from '../heading/Heading'
import type {HeadingProps} from '../heading/Heading'
import LazyImage, {LazyImageProps} from '../image/LazyImage'
import Box from '../layout/Box'
import Text from '../text/Text'
import type {TextProps} from '../text/Text'
import Desktop from '../layout/Desktop'
import Mobile from '../layout/Mobile'
import Section from '../layout/Section'
import Container from '../layout/Container'

export interface TwoColumnsProps {
  isRtl?: boolean
  headline?: string
  content?: string
  button?: ButtonProps
  image?: LazyImageProps
}

const TwoColumnsHeading = styled(Heading).attrs<HeadingProps>({
  as: 'h2',
  $variant: ['h3', 'h2', 'h2', 'h2'],
  $mb: [24, 16, 16, 16],
  $styles: {
    maxWidth: [null, 455, 455, 455],
  },
})({})

const TwoColumnsText = styled(Text).attrs<TextProps>({
  $variant: 'p1',
  $transparency: 0.3,
  $mb: [24, 40, 40, 40],
  $styles: {
    maxWidth: [null, 455, 455, 455],
  },
})({})

const TwoColumns: React.FC<TwoColumnsProps> = ({
  headline,
  content,
  button,
  image,
  isRtl = false,
}) => {
  return (
    <Section>
      <Container>
        <Grid isRtl={isRtl} columns={2}>
          <Desktop>
            <Box>
              {headline && <TwoColumnsHeading>{headline}</TwoColumnsHeading>}
              {content && <TwoColumnsText>{content}</TwoColumnsText>}
              {button && <Button {...button} />}
            </Box>
          </Desktop>
          <Box>
            {headline && (
              <Mobile>
                <TwoColumnsHeading>{headline}</TwoColumnsHeading>
              </Mobile>
            )}
            {image && (
              <Box
                $mb={[24, null, null, null]}
                $styles={{
                  position: 'relative',
                  height: [325, 550, 550, 550],
                  width: [325, 550, 550, 550],
                }}
              >
                <LazyImage {...image} />
              </Box>
            )}
            <Mobile>
              {content && <TwoColumnsText>{content}</TwoColumnsText>}
              {button && <Button {...button} />}
            </Mobile>
          </Box>
        </Grid>
      </Container>
    </Section>
  )
}

export default TwoColumns
